import { gql } from "@apollo/client";

// Query: Get all API keys for a tenant
export const GET_API_KEYS_QUERY = gql`
  query GetApiKeys($tenantId: String!) {
    getApiKeys(tenantId: $tenantId) {
      tenantId
      entityType
      entityId
      apiName
      secretName
      secretArn
      status
      validated
      registeredAt
      lastUsed
      lastTested
      validationDetails {
        message
        responseStatus
        searchEngine
        note
      }
      metadata {
        operation
        environment
        createdBy
        version
      }
    }
  }
`;

// Query: Get a specific API key record
export const GET_API_KEY_QUERY = gql`
  query GetApiKey($tenantId: String!, $apiName: String!) {
    getApiKey(tenantId: $tenantId, apiName: $apiName) {
      tenantId
      entityType
      entityId
      apiName
      secretName
      secretArn
      status
      validated
      registeredAt
      lastUsed
      lastTested
      validationDetails {
        message
        responseStatus
        searchEngine
        note
      }
      metadata {
        operation
        environment
        createdBy
        version
      }
    }
  }
`;

// Query: Get all available external APIs
export const GET_EXTERNAL_APIS_QUERY = gql`
  query GetExternalApis($tenantId: String!) {
    getExternalApis(tenantId: $tenantId) {
      tenantId
      entityType
      entityId
      apiName
      displayName
      version
      baseUrl
      requiresApiKey
      description
      documentationUrl
      supportedOperations
      rateLimits
      createdAt
      updatedAt
      metadata {
        createdBy
        environment
      }
    }
  }
`;

// Query: Get API key registration status
export const GET_API_KEY_REGISTRATION_STATUS_QUERY = gql`
  query GetApiKeyRegistrationStatus($executionArn: String!) {
    getApiKeyRegistrationStatus(executionArn: $executionArn) {
      executionArn
      status
      startDate
      endDate
      input
      output
      error
    }
  }
`;

// Mutation: Register a new API key
export const REGISTER_API_KEY_MUTATION = gql`
  mutation RegisterApiKey($input: RegisterApiKeyInput!) {
    registerApiKey(input: $input) {
      success
      message
      executionArn
      apiName
      tenantId
      error
    }
  }
`;

// Mutation: Test an existing API key
export const TEST_API_KEY_MUTATION = gql`
  mutation TestApiKey($input: TestApiKeyInput!) {
    testApiKey(input: $input) {
      success
      isValid
      message
      apiName
      tenantId
      testedAt
      validationDetails {
        message
        responseStatus
        searchEngine
        note
      }
      error
    }
  }
`;

// Mutation: Update an existing API key
export const UPDATE_API_KEY_MUTATION = gql`
  mutation UpdateApiKey($input: UpdateApiKeyInput!) {
    updateApiKey(input: $input) {
      success
      message
      executionArn
      apiName
      tenantId
      error
    }
  }
`;

// Mutation: Delete an API key
export const DELETE_API_KEY_MUTATION = gql`
  mutation DeleteApiKey($input: DeleteApiKeyInput!) {
    deleteApiKey(input: $input) {
      success
      message
      apiName
      tenantId
      error
    }
  }
`;

// Subscription: Subscribe to API key registration status updates
export const ON_API_KEY_REGISTRATION_UPDATE_SUBSCRIPTION = gql`
  subscription OnApiKeyRegistrationUpdate($executionArn: String!) {
    onApiKeyRegistrationUpdate(executionArn: $executionArn) {
      executionArn
      status
      startDate
      endDate
      input
      output
      error
    }
  }
`;

// Subscription: Subscribe to API key test results
export const ON_API_KEY_TEST_RESULT_SUBSCRIPTION = gql`
  subscription OnApiKeyTestResult($tenantId: String!, $apiName: String!) {
    onApiKeyTestResult(tenantId: $tenantId, apiName: $apiName) {
      success
      isValid
      message
      apiName
      tenantId
      testedAt
      validationDetails {
        message
        responseStatus
        searchEngine
        note
      }
      error
    }
  }
`;

// Aliases for backward compatibility
export const CREATE_API_KEY_MUTATION = REGISTER_API_KEY_MUTATION;
export const LIST_API_KEYS_QUERY = GET_API_KEYS_QUERY;
export const VALIDATE_API_KEY_MUTATION = TEST_API_KEY_MUTATION;
